import React from 'react'

export default function SetTransferGroup() {
  return (
    <div>setTransferGroup</div>
  )
}
